// extracted by mini-css-extract-plugin
module.exports = {"Shannon":"TextGroupSectionF_Shannon__20qLn","TextContainer":"TextGroupSectionF_TextContainer__bPF3A"};